const version = {"builtAt":"2020-03-19T17:27:15.658Z","branch":"master","commit":"3153e68"};

if (typeof module !== 'undefined' && module.exports) {
    module.exports = version;
}
